export enum TAX_INFO_FORM_FIELDS {
	country = 'country',
	number = 'number',
	authority = 'authority',
}

export interface TaxInfoFormValues {
	[TAX_INFO_FORM_FIELDS.country]: string;
	[TAX_INFO_FORM_FIELDS.number]?: string;
	[TAX_INFO_FORM_FIELDS.authority]?: string;
}
